module.exports = __webpack_public_path__ + "static/media/inter-bold.aed27700.woff2";